/**
 * Approved copy explaining an organization's order limits. Both the Account Settings Order card and
 * the Developer Tools setup banner surface the same two limits, so the strings live here rather than
 * in either feature — they change together whenever product revises the limits, and a copy that drifts
 * between the two screens is a defect.
 *
 * Must match the design exactly.
 */

export const DAILY_ORDER_LIMIT_TOOLTIP =
  "Maximum number of orders you can place within a 24-hour period. If you would like to increase this number, please reach out to RPI Customer Support team at printapicustomersupport@rpiprint.com.";

export const QUEUED_ORDER_LIMIT_TOOLTIP =
  "The maximum number of orders that can be queued, exceeding the Daily Order Limit. Any new orders that go beyond this limit will not be accepted.";
